export const PAYMENT_FLOW_VIEWS = {
  PAYMENT_METHODS_LIST: 0,
  CARD_FILL: 2,
};

export const PaymentMethodsEnum = {
  None: 0,
  Balance: 1,
  Card: 2,
  PromPackageOrder: 3,
  Google: 4,
  Apple: 5,
  Points: 6,
  Emoney: 7,
  TbcInstallment: 8,
  Credo: 9,
  ReqInvoice: 10,
  Amex: 11,
  EmoneyBalance: 12,
  MyCoins: 13,
  SavedCard: 14,
  TbcMobileBank: 15,
  TbcBnpl: 16,
  BogInstallment: 18,
  BogCard: 19,
  OtherBankCard: 20,
  TbcCard: 21,
};

export const PaymentMethodsIconsEnum = {
  [PaymentMethodsEnum.Balance]: 'balance-icon-i',
  [PaymentMethodsEnum.TbcCard]: 'pay-card w-48px h-32px',
  [PaymentMethodsEnum.PromPackageOrder]: '',
  [PaymentMethodsEnum.Google]: 'google-pay w-48px h-32px',
  [PaymentMethodsEnum.Apple]: 'applePay-i w-48px h-32px',
  [PaymentMethodsEnum.Points]: 'love-card-icon-i',
  [PaymentMethodsEnum.Emoney]: 'paybox-i',
  [PaymentMethodsEnum.TbcInstallment]: 'tbc-installment',
  [PaymentMethodsEnum.ReqInvoice]: 'pay-invoice',
  [PaymentMethodsEnum.Amex]: 'american-icon w-40px h-28px',
  [PaymentMethodsEnum.EmoneyBalance]: 'pay-emoney',
  [PaymentMethodsEnum.MyCoins]: 'Crypto',
  [PaymentMethodsEnum.TbcMobileBank]: 'tbc-bank-icon w-24px h-24px',
  [PaymentMethodsEnum.TbcBnpl]: 'tbc-bank-icon w-24px h-24px',
};

export const PaymentGroupEnum = {
  Cards: 1,
};

export const groupPaymentMethods = (groups, methods) => {
  const groupMap = new Map(groups.map((g) => [g.id, g.name]));

  return methods.reduce((acc, { id, name, group_id }) => {
    const groupName = groupMap.get(group_id);

    if (!groupName) {
      acc.push({ id, name, group_id });
      return acc;
    }

    let group = acc.find((item) => 'paymentMethods' in item && item.id === group_id);

    if (!group) {
      group = { id: group_id, name: groupName, paymentMethods: [], group_id };
      acc.push(group);
    }

    group.paymentMethods.push({ id, name });
    return acc;
  }, []);
};

// validation errors come as objects like { PrIDs: "Invalid product" }, which can't be rendered directly
export const formatPaymentError = (statusMessage) => {
  if (!statusMessage || typeof statusMessage === 'string') return statusMessage;

  return Object.values(statusMessage).flat().map((error) => <div key={error}>{error}</div>);
};
